import React from 'react'
import '../index.scss'

const DatePaginatorSkeleton: React.FC = () => {
  return (
    <div className="~box-border ~rounded-sm ~p-2.5 ~pl-4 ~pr-4 ~m-5 ~mb-0 ~mt-0 ~bg-white ~max-h-[58px] ~flex ~justify-between ~items-center">
      <div className="animateDateDetails ~box-border ~rounded-sm ~w-[224px] ~h-8" />
      <div className="animateDatePaginator ~box-border ~rounded-sm ~w-[456px] ~h-[37px]" />
    </div>
  )
}

export default DatePaginatorSkeleton
